// @mui
import Container from '@mui/material/Container';
import { useSettingsContext } from 'src/components/settings';
import NewsLetterCreatePage from './news-letter-create-page';

// ----------------------------------------------------------------------

export default function CreateNewsLetter() {
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <NewsLetterCreatePage />
        </Container >
    );
}
